import { Modal as MuiModal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@design-system/components/button/button';
import { FormFaq } from '../../model/programForm.types';
import { FAQ_SUGGESTIONS } from '../../model/programForm.suggestions';
import * as styles from './FaqSuggestionsModal.css';

type FaqSuggestionsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (suggestion: FormFaq) => void;
};

export const FaqSuggestionsModal = ({
  isOpen,
  onClose,
  onSelect,
}: FaqSuggestionsModalProps) => (
  <MuiModal open={isOpen} onClose={onClose}>
    <div className={styles.modal}>
      <button
        type="button"
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close"
      >
        <FontAwesomeIcon icon={faClose} />
      </button>
      <h2 className={styles.title}>FAQ suggestions</h2>
      <div className={styles.list}>
        {FAQ_SUGGESTIONS.map((faq, index) => (
          <div key={index} className={styles.row}>
            <div className={styles.rowText}>
              <div className={styles.question}>{faq.question}</div>
              <div className={styles.answer}>{faq.answer}</div>
            </div>
            <div className={styles.rowAction}>
              <Button
                color="primaryTonal"
                onClick={() => {
                  onSelect(faq);
                  onClose();
                }}
              >
                Use FAQ
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </MuiModal>
);
